import WorkflowLibraryPage from "../workflows/components/WorkflowLibraryPage";

export default function TemplateLibraryWrapper() {
  return <WorkflowLibraryPage />;
}
